import * as React from 'react';

const SvgUndo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.42383 19.5H13.1738C16.4875 19.5 19.1738 16.8137 19.1738 13.5V12.9079C19.1738 9.59419 16.4875 6.90789 13.1738 6.90789H4.17383M4.17383 6.90789L8.45954 3M4.17383 6.90789L8.45954 10.8158", stroke: "currentColor", strokeWidth: 2.5, strokeLinecap: "round", strokeLinejoin: "round" }));

export { SvgUndo as default };
//# sourceMappingURL=undo.svg.js.map
